'use client';

import Header from '@/components/header/Header';
import OrderLayoutHeader from '@/components/orderLayoutHeader/OrderLayoutHeader';
import type { GlobalHeaderStoryblok } from '@/types/component-types-sb';
import { isContentPage } from '@/types/typeguards';
import type { ISbStoryData, SbBlokData } from '@storyblok/react/rsc';

const PageHeader: React.FC<{ content: SbBlokData; headerStory: ISbStoryData<GlobalHeaderStoryblok>; slug: string }> = ({
  content,
  headerStory,
  slug,
}) => {
  if (!content) return null;

  const headerComponent =
    isContentPage(content) && content.useMiniHeader ? (
      <OrderLayoutHeader showLogoOnMobile showAnchorNavigation />
    ) : (
      <Header blok={headerStory.content} />
    );

  return <>{headerComponent}</>;
};

export default PageHeader;
